import downloadingPage from "./downloadingPage.json";

export default {
  downloadingPage,
};
